import { call, select, put } from 'redux-saga/effects';
import jwtDecode from 'jwt-decode';
import storage from 'utils/storage';
import { getHistory } from 'utils/history';
import transformVenue from 'transform/venue';
import { getCurrentLocation } from 'utils/geolocation';
import { sleep } from 'utils/promise';
import api_v2 from 'services/api_v2';
import AppActions, { AppSelectors } from './AppRedux';
import AuthActions, { AuthSelectors } from './AuthRedux';
import PayActions, { PaySelectors } from './PayRedux';
import { loadPromotions } from './PromotionSaga';
import { loadPaymentMethods } from './PaySaga';

export function* loadVenues() {
  const token = yield select(AuthSelectors.selectToken);

  const api = api_v2(token);
  yield put(AppActions.setLoadingVenues(true));

  const resp = yield call(api.getVenues);

  yield put(AppActions.setVenues(resp.map((v) => transformVenue(v))));
  yield put(AppActions.setLoadingVenues(false));
}

export function* getGeoCurrentLocation() {
  let location = yield call(getCurrentLocation);
  if (!location.lat) {
    // try again
    yield call(sleep, 3000);
    location = yield call(getCurrentLocation);
  }

  console.log('Get Current Location = ', JSON.stringify(location));
  yield put(AppActions.setGeoLocation(location.lat, location.lng));
}

function* getTicketByUser(token) {
  let ticket = null;
  try {
    const api = api_v2(token);
    ticket = yield call(api.getTicketByUser);
  } catch (error) {
    console.log(error);
  }
  return ticket;
}

export function* logout() {
  yield call(storage.removeItem, 'vemospay-token');
  yield call(storage.removeItem, 'vemospay-user');
  yield put(AuthActions.setUser(null));
  yield put(AppActions.reset());
  const history = getHistory();
  history.push('/auth/sign');
}

export function* login(actions) {
  const { token, noRedirect } = actions;
  const redirectUrl = yield select(AuthSelectors.selectRedirectUrl);
  try {
    const user = jwtDecode(token);

    if (user.exp < new Date() / 1000) {
      yield call(logout);
      yield call(loadVenues);
      throw new Error('Your token is expired');
    }
    
    yield put(AuthActions.setToken(token));
    storage.setItem('vemospay-token', token);
    const history = getHistory();

    if (!user.phoneVerified && !noRedirect) {
      history.push('/verify-code');
    } else {
      yield call(loadPaymentMethods);
      const methods = yield select(PaySelectors.selectPaymentMethods);
      if (!methods.length) {
        history.push('/card-notice');
      }
    }

    yield call(loadVenues);

    const invite = yield select(AppSelectors.selectInvite);
    if (invite) {
      history.push(`/invite/${invite.venueId}/${invite.ticketId}`);
    }

    if (redirectUrl) {
      yield put(AuthActions.setRedirectUrl(''));
      history.push(redirectUrl);
    }

    const resp = yield call(getTicketByUser, token);
    if (resp) {
      yield put(AppActions.setVenue(resp.venueId));
      yield put(PayActions.setTicket(resp));
    }

    yield call(loadPromotions, {});
  } catch (e) {
    console.error(e);
    yield put(
      AppActions.setToast(e.message || 'There was problem with token', 'danger')
    );
  }
}
